// path: frontend/src/api/queries/meta.js
/**
 * Справочники, env-конфиг и CSRF-whitelist с GET /api/v1/meta.
 *
 * staleTime: Infinity — тело статично в рамках деплоя (ETag + Cache-Control:
 * immutable на бэке). Инвалидация — только при перезагрузке процесса
 * бэкенда (новый ETag), на клиенте это происходит при следующем
 * монтировании/refetch. В рамках сессии meta не меняется.
 *
 * useMetaQuery() — для справочников и конфига, которые раньше жили в
 * constants.js. ALLOWED_EMAIL_DOMAINS, FILE_LIMITS, ROLES, TASK_STATUSES,
 * PROJECT_STATUSES, PRIORITIES, PROJECT_PRIORITIES, ADMIN_PROJECT_PRIORITIES,
 * SUBSTITUTION_KINDS, TASK_STATUS_ORDER, WEEKLY_REMINDER_PERIODS — всё отсюда.
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "../client";

export const META_KEY = ["meta"];

export function useMetaQuery(options = {}) {
  return useQuery({
    queryKey: META_KEY,
    queryFn: () => api.get("/meta"),
    staleTime: Infinity,
    ...options,
  });
}
